module.exports = __webpack_public_path__ + "static/img/img5.467ba77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/img5.png
// module id = dAi8
// module chunks = 0